const GATSBY_PUZZEL_CUSTOMER_KEY = process.env.GATSBY_PUZZEL_CUSTOMER_KEY!;
const PUZZEL_LOADER_ID = 'pzlModuleLoader';
const PUZZEL_LOADER_SRC = 'https://app-cdn.puzzel.com/public/js/pzl_loader.js';

let startedInit = false;

const init = () => {
  if (typeof window === 'undefined' || startedInit) {
    return;
  }

  if (document.getElementById(PUZZEL_LOADER_ID)) {
    startedInit = true;
    return;
  }

  startedInit = true;

  const loader = document.createElement('script');
  loader.async = true;
  loader.type = 'text/javascript';
  loader.src = PUZZEL_LOADER_SRC;
  loader.setAttribute('id', PUZZEL_LOADER_ID);
  loader.setAttribute('data-customer-id', GATSBY_PUZZEL_CUSTOMER_KEY);

  loader.onerror = () => {
    startedInit = false;
  };

  document.body.append(loader);
};

const newPuzzel = { init };

export default newPuzzel;
